import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { RedirectService } from '../redirect/redirect.service';
import { NewTeamService } from './new-team.service';
declare var $: any;


@Component({
    selector: 'app-new-team',
    templateUrl: './new-team.component.html',
    styleUrls: ['./new-team.component.scss']
})
export class NewTeamComponent implements OnInit {

    teamObj = {
        admins: [{}]
    };

    teamForm: FormGroup;
    errMessage: string = '';
    minDate: string = '';
    adminError: string = '';
    areas: any[] = [];
    notificationEmails: any[] = [];
    newarea: string = '';
    workAreaError: Boolean = false;
    authModeError: Boolean = false;
    notificationEmailsError: Boolean = false;
    authMode: any;
    clientIdError:Boolean = false;
    clientSecretError:Boolean = false;
    tenantNameError:Boolean = false;

    authTypes: any[] = [];
    selectedAuthType: any;
    selectedAuthTypeIndex: number;
    itemList = [];
    selectedItems = [];
    settings = {
        singleSelection: false,
        text: "Select Assets",
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true,
        classes: "myclass custom-class",
        maxHeight: 200,
        enableFilterSelectAll: false
    };

    constructor(
        private _newTeamService: NewTeamService,
        private _router: Router,
        private _formBuilder: FormBuilder,
        private _capabilityEngineService: CapabilityEngineService,
        private _redirectService: RedirectService,
        private _activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {


        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {
            this.minDate = moment().format('YYYY-MM-DD');
            this.teamForm = this._formBuilder.group({
                name: ['', [Validators.required, Validators.pattern(/.*[^ ].*/)]],
                contact: ['', [Validators.maxLength(15), Validators.pattern(/^\+[1-9]{1}[0-9]{3,14}$/)]],
                // tslint:disable-next-line:max-line-length
                websiteReferenceUrl: ['', [Validators.pattern(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/)]],
                validUpto: ['', [Validators.required]],
                admins: this._formBuilder.array([]),
                areas: [[], [Validators.maxLength(50)]],
                notificationEmails: [[]],
                clientId: ['', []],
                clientSecret: ['', []],
                tenantName: ['', []]
                //    authMode:['', [Validators.required]]
            });

            this.addAdmin();

            this._newTeamService.getAuthTypes()
                .subscribe(
                    (result) => {
                        this.authTypes = result['result'];
                        console.log(this.authTypes);
                    });
        }

        this.getRolesCap();

    }

    getRolesCap() {
        this._newTeamService.getRoles().subscribe(
            (res: any) => {
                if (res.result && res.result.appTypes)
                    _.forEach(res.result.appTypes, (val, i) => {
                        this.itemList.push({ id: val.type + i, itemName: val.type });
                        this.selectedItems.push({ id: val.type + i, itemName: val.type });
                    });
            },
            (err) => {
                console.log(err);
            }
        )
    }

    selectAuthmode(index: number) {
        console.log(index);
        if (index == 0) {
            this.authModeError = true;
            return;
        }
        this.selectedAuthTypeIndex = index - 1;
        if (index != 0) {
            this.selectedAuthType = this.authTypes[this.selectedAuthTypeIndex].authType;
        } else {
            this.errMessage = "Please enter authmode";
        }

    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    removeErrorMessage() {
        this.errMessage = '';
    }

    addAdmin() {
        const control = this._formBuilder.group({
            name: ['', [Validators.required, Validators.pattern(/.*[^ ].*/)]],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', [Validators.maxLength(15), Validators.pattern(/^\+[1-9]{1}[0-9]{3,14}$/)]]
        });
        (<FormArray>this.teamForm.get('admins')).push(control);
    }

    removeAdmin(index: number) {
        console.log(this.teamForm.get('admins')['controls']);
        this.teamForm.get('admins')['controls'].splice(index, 1);
    }

    createTeam() {
        // console.log('hello word');
        this.errMessage = '';
        this.workAreaError = false;
        this.authModeError = false;
        this.clientIdError = false;
        this.clientSecretError = false;
        this.tenantNameError = false;

        if (this.areas) {
            var context = this;
            _.each(this.areas, function (area: any) {
                console.log(area.displayValue.length);
                if (area.displayValue.length > 50) {
                    context.workAreaError = true;
                    return;
                }
            });
        }
        if(this.selectedAuthTypeIndex===-1 || this.selectedAuthTypeIndex===undefined){
                      this.authModeError = true;
                          return;
                 }else{
                      this.authModeError = false;

                   }

                   if (this.selectedAuthType === 'azure' || this.selectedAuthType === 'auth0') {

                            if (this.teamForm.value['clientId'].length == 0) {
                                this.clientIdError = true;
                            } else {
                                this.clientIdError = false;
                            }
                            if (this.teamForm.value['clientSecret'].length == 0) {
                                this.clientSecretError = true;
                            } else {
                                this.clientSecretError = false;
                            }

                            if (this.teamForm.value['tenantName'].length == 0) {
                                this.tenantNameError = true;
                            } else {
                                this.tenantNameError = false;
                            }

                            if (this.clientIdError || this.clientSecretError || this.tenantNameError) {
                                return;
                            }
                             }

        if (this.notificationEmailsError) {
            return;
        }

        const formElements = [
            {
                'elementId': 'shortText',
                'properties': {
                    'default': [
                        {
                            'title': 'User name',
                            'type': '_fh_user:name'
                        },
                        {
                            'title': 'Team name',
                            'type': '_fh_team:name'
                        }
                    ]
                }
            },
            {
                'elementId': 'longText',
                'properties': {
                    'default': [
                        {
                            'title': 'User name',
                            'type': '_fh_user:name'
                        },
                        {
                            'title': 'Team name',
                            'type': '_fh_team:name'
                        }
                    ]
                }
            },
            {
                'elementId': 'readText'
            },
            {
                'elementId': 'numberField'
            },
            {
                'elementId': 'dropdown'
            },
            {
                'elementId': 'timePicker'
            },
            {
                'elementId': 'datePicker'
            },
            {
                'elementId': 'multiChoice'
            },
            {
                'elementId': 'checkBox'
            },
            {
                'elementId': 'location'
            },
            {
                'elementId': 'image'
            },
            {
                'elementId': 'signature'
            },
            {
                'elementId': 'freeFormDraw'
            },
            {
                'elementId': 'url'
            },
            {
                'elementId': 'pdf'
            }
        ];

        const hazardFormElements = [
            {
                'elementId': 'hazard'
            },
            {
                'elementId': 'hazardWithLabel'
            }
        ];

        if (this.teamForm.valid) {
            this.teamForm.value['workAreas'] = _.map(this.areas, 'displayValue');
            delete this.teamForm.value.areas;
            this.teamForm.value['notificationEmails'] = _.map(this.notificationEmails, 'displayValue');
            console.log(this.teamObj, this.teamForm.value);
            // TODO: THIS SHOULD HAPPEN DYNAMICALLY
            const authentication = this.authTypes[this.selectedAuthTypeIndex];
            this.teamForm.value['appType'] = _.map(this.selectedItems, (item) => { return item.itemName});

            this.teamForm.value['formElements'] = formElements;
            if ((this.teamForm.value['appType']).indexOf('MSHA') > -1) {
                this.teamForm.value['formElements'] = [...formElements, ...hazardFormElements]; 
            }
            this.teamForm.value['authentication'] = {
                authDetails: {
                    _id: authentication._id,
                    authType: authentication.authType
                },
                authConfig: {
                    clientId: this.teamForm.value['clientId'],
                    clientSecret: this.teamForm.value['clientSecret'],
                    tenantName: this.teamForm.value['tenantName']
                }
            };

            if (this.selectedAuthType !== 'azure' && this.selectedAuthType !== 'auth0') {
                this.teamForm.value['authentication'].authConfig = {};
            }
            this._newTeamService.createTeam(this.teamForm.value)
                .subscribe((result2) => {
                    console.log('result2 ', result2);
                    this._router.navigateByUrl('/teamsList');
                },
                    (err) => {
                        this.errMessage = err.error.message;
                        if (err.error.message.includes('email-id already exists')) {
                            this.adminError = err.error.message;
                            this.errMessage = '';
                        }
                        // TODO: Should remove this after figuring out the issue
                        if (err.error.message.includes('409')) {
                            this._router.navigateByUrl('/teamsList');
                        }
                    }
                );
        } else {
            this.validateAllFormFields(this.teamForm);
        }

    }


    isTeamFieldValid(field: string) {
        return !this.teamForm.get(field).valid && this.teamForm.get(field).touched;
    }

    isArrayFieldValid(index: number, field: string, uniqueField: string) {
        const control = this.teamForm.get('admins')['controls'][index];
        return !control.get(field).valid && control.get(field).touched;
    }

    displayTeamFieldCss(field: string) {
        return {
            'has-error': this.isTeamFieldValid(field)
        };
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            } else if (control instanceof FormArray) {
                _.forEach(control.controls, (data: FormGroup) => {
                    this.validateAllFormFields(data);
                });
            }
        });
    }

    validateEmail(email) {
        // tslint:disable-next-line:max-line-length
        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validateWorkArea(event) {
        this.workAreaError = false;
        if (event.tag.displayValue && event.tag.displayValue.length > 50) {
            let curArea = this.areas[this.areas.length - 1].displayValue;
            setTimeout(function () {
                $('#workarea .tags-input__input-field')[0].value = curArea;
            }, 10);
            this.areas.pop();
            this.workAreaError = true;
        }

    }

    onTagsChanged(event) {
        this.notificationEmailsError = false;
        // console.log(event,this.notificationEmails);
        if (event.tag.displayValue && !this.validateEmail(event.tag.displayValue)) {
            this.notificationEmails.pop();
            this.notificationEmailsError = true;

        }
    }

    validateEmailBeforeInput(event) {
        this.notificationEmailsError = false;
        if (event.tag.displayValue && !this.validateEmail(event.tag.displayValue)) {
            let curEmail = this.notificationEmails[this.notificationEmails.length - 1].displayValue;
            setTimeout(function () {
                $('#notificationEmails .tags-input__input-field')[0].value = curEmail;
            }, 10);
            this.notificationEmails.pop();
            this.notificationEmailsError = true;
        }
    }
}






// WEBPACK FOOTER //
// ./src/app/new-team/new-team.component.ts